"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var url_param_1 = require("./url-param");
function removeParamsFromHistory(paramsToRemove) {
    var params = url_param_1.urlParamsToObj(window.location.search);
    paramsToRemove.forEach(function (key) {
        delete params[key];
    });
    var newQueryParams = url_param_1.objToUrlParams(params);
    var uri = "" + window.location.pathname;
    if (newQueryParams) {
        uri = uri + "?" + newQueryParams;
    }
    if (window.location.hash) {
        uri = "" + uri + window.location.hash;
    }
    window.history.replaceState(window.history.state, '', uri);
}
exports.removeParamsFromHistory = removeParamsFromHistory;
